import React from 'react';
import { HStack, Text, IconButton, useToast, Tooltip } from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';

const CopyableText = ({ text, label = 'Copy to clipboard', colorMode }) => {
    const toast = useToast();

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(text);
            toast({
                title: 'Copied!',
                description: `"${text}" copied to clipboard.`,
                status: 'success',
                duration: 2000,
                isClosable: true,
            });
        } catch (err) {
            toast({
                title: 'Failed to copy',
                status: 'error',
                duration: 2000,
                isClosable: true,
            });
        }
    };

    return (
        <HStack
            spacing={2}
            pb={3}
        >
            <Text fontFamily="mono" fontSize="sm" noOfLines={1}
                bg={colorMode === 'light' ? 'white' : 'gray.700'}
                color={colorMode === 'light' ? 'gray.800' : 'white'}
                borderColor={colorMode === 'light' ? 'gray.200' : 'gray.600'}
                p={3}
                borderRadius={5}
                borderStyle="solid"
                borderWidth={1}>
                {text}
            </Text>
            <Tooltip label={label}>
                <IconButton
                    icon={<CopyIcon />}
                    aria-label="Copy"
                    size="sm"
                    onClick={handleCopy}
                />
            </Tooltip>
        </HStack>
    );
};

export default CopyableText;